import React from 'react';
import Card from './card';

export default function GrilldRelish() {
  return (
    <div className="grilld">
      <Card
        title="Relish"
        className="relish"
      />
    </div>
  );
}
